import RecapMajModaleService from './services/recap.maj.modale.service';
import RecapMajModaleComponent from './components/recap-maj-modale';

const moduleName = 'app.massia.common.recap-maj-modale';

angular
	.module(moduleName, [])

	.service('RecapMajModaleService', RecapMajModaleService)
	.component('recapMajModale', RecapMajModaleComponent);

export default moduleName;
